<template>
  <div class="reciteForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :disabled="fundPaymentBillFlag == '1' ? false : !isEdit || !canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  export default {
    name: 'reciteForm',
    components: {
      baseForm,
    },
    props: ['isEdit', 'departmentList', 'canEdit', 'fundPaymentBillFlag'],
    data() {
      return {
        baseData: {
          id: null,
          endorseDate: null,
          endorsePurpose: null,
          endorseDepartmentNo: null,
          endorseDepartmentName: null,
          endorseeName: null,
          paymentNum: null,
          marginRatio: null,
          ourDiscountInterest: null,
          upstreamDiscountInterest: null,
          downstreamDiscountInterest: null,
        },
      };
    },
    mounted() {},
    computed: {
      baseDataOptions() {
        //基础数据表单配置
        return [
          {
            // 背书日期
            type: 'date',
            label: this.$t('billDetail.reciteForm.endorseDate'),
            prop: 'endorseDate',
          },
          {
            // 背书目的
            type: 'input',
            label: this.$t('billDetail.reciteForm.endorsePurpose'),
            prop: 'endorsePurpose',
            maxlength: '256',
          },
          {
            // 背书部门
            type: 'select',
            label: this.$t('billDetail.reciteForm.endorseDepartmentNo'),
            prop: this.canEdit ? 'endorseDepartmentNo' : 'endorseDepartmentName',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 被背书人
            type: 'input',
            label: this.$t('billDetail.reciteForm.endorseeName'),
            prop: 'endorseeName',
            maxlength: '20',
          },
          {
            // 上游贴息
            type: 'input',
            label: '上游贴息',
            prop: 'upstreamDiscountInterest',
            placeholder: '请输入',
          },
          {
            // 下游贴息
            type: 'input',
            label: '下游贴息',
            prop: 'downstreamDiscountInterest',
            placeholder: '请输入',
          },
          {
            // 我方贴息
            type: 'input',
            label: '我方贴息',
            prop: 'ourDiscountInterest',
            placeholder: '请输入',
          },
          // {
          //   // 付款单号
          //   type: 'input',
          //   label: this.$t('billDetail.reciteForm.paymentNum'),
          //   prop: 'paymentNum',
          //   placeholder: this.$t('billDetail.placeholder.auto'),
          //   disabled: true,
          //   maxlength: '20',
          // },
          // { // 背书内部保证金比率
          //   type: "amountNumber",
          //   label: this.$t("billDetail.reciteForm.marginRatio"),
          //   prop: "marginRatio",
          //   precision: this.$globalVar.iPoint,
          // },
        ];
      },
    },
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'endorseDepartmentNo') {
          this.baseData.endorseDepartmentName = value.endorseDepartmentNo
            ? this.departmentList.find((item) => item.value == value.endorseDepartmentNo).label
            : null;
        }
      },
      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
